const initialPayment = {
    payments: [],
    paymentmessages : {},
};

const paymentReducer = (payment = initialPayment, action) => {
    switch (action.type) {
        case 'GET_PAYMENT':
            return {
                ...payment, payments: action.payload.data
            };
        case 'ADD_PAYMENT':
            return {
                ...payment, paymentmessages: action.payload.data
            };
        case "UPDATE_PAYMENT":
            return {
                ...payment, paymentmessages: action.payload.data
            };
        case "DELETE_PAYMENT":
            return {
                ...payment, paymentmessages: action.payload.data
            };
        case "REVOKE_PAYMENT":
            return {
                ...payment, paymentmessages: action.payload.data
            };
        default:
            return payment;

    }
}
export default paymentReducer;